import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f200125"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main user-layout-register",
  style: {"width":"400px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", null, "修改登陆密码")
], -1))
const _hoisted_3 = { style: { width: '240px' } }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 强度： ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "请至少输入 6 个字符。请不要使用容易被猜到的密码。")
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("+86")
const _hoisted_7 = { style: {"color":"#848485"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#5a647e"} }, "返回登录", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_mail_outlined = _resolveComponent("mail-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      id: "formRegister",
      layout: "vertical"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.username)), {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.modelRef.username,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.username) = $event)),
              placeholder: "账号",
              size: "large",
              type: "text"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 16),
        _createVNode(_component_a_popover, {
          visible: _ctx.state.passwordLevelChecked,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.passwordLevelChecked) = $event)),
          "get-popup-container": trigger => trigger.parentElement,
          trigger: ['focus'],
          placement: "rightTop"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.passwordLevelName), 1)
              ]),
              _createVNode(_component_a_progress, {
                percent: _ctx.state.percent,
                "show-info": false,
                "stroke-color": _ctx.passwordLevelColor
              }, null, 8, ["percent", "stroke-color"]),
              _hoisted_5
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.password)), {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.modelRef.password,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.password) = $event)),
                  placeholder: "至少6位密码，区分大小写",
                  size: "large",
                  onClick: _ctx.handlePasswordInputClick
                }, null, 8, ["value", "onClick"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["visible", "get-popup-container"]),
        _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.password2)), {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.modelRef.password2,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.password2) = $event)),
              placeholder: "确认密码",
              size: "large"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 16),
        _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.mobile)), {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.modelRef.mobile,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.mobile) = $event)),
              placeholder: "11 位手机号",
              size: "large"
            }, {
              addonBefore: _withCtx(() => [
                _createVNode(_component_a_select, {
                  "default-value": "+86",
                  disabled: "",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "+86" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 16),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: "16" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.modelRef.code,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.code) = $event)),
                  placeholder: _ctx.$t('请输入验证码'),
                  autocomplete: "off",
                  size: "large",
                  style: {"width":"100%"}
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_mail_outlined, { class: "prefixIcon" })
                  ]),
                  _: 1
                }, 8, ["value", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: "8" }, {
              default: _withCtx(() => [
                (_ctx.modelRef.num <= 0)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      size: "large",
                      type: "link",
                      onClick: _ctx.handleGetCode
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('获取验证码')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      size: "large",
                      type: "link"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('重新获取')) + "(" + _toDisplayString(_ctx.modelRef.num) + "s)", 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              loading: _ctx.loginBtn,
              class: "login-button",
              size: "large",
              type: "primary",
              onClick: _ctx.handleUpdatePassword
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              style: {"float":"right"},
              type: "link",
              onClick: _ctx.handleLogin
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}